export default {
  survey: {
    restartSurvey: 'Eine neue Umfrage starten',
    sendingSurvey: 'Ihre Umfrage wird übermittelt. Bitte warten...',
    sending: 'Wird übermittelt...',
    checkoutError: 'Beim Übermitteln Ihres Formulars ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
    errorSending: 'Es tut uns leid, wir konnten Ihre Umfrage nicht übermitteln. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    retryBtnText: 'Wiederholen',
    doneBtnText: 'Fertig',
    uploadImage: 'Foto hochladen',
    submitFeedback: 'Feedback abgeben'
  }
};